import { render, staticRenderFns } from "./CreatePoints.vue?vue&type=template&id=f9aad28e"
import script from "./CreatePoints.vue?vue&type=script&lang=js"
export * from "./CreatePoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9aad28e')) {
      api.createRecord('f9aad28e', component.options)
    } else {
      api.reload('f9aad28e', component.options)
    }
    module.hot.accept("./CreatePoints.vue?vue&type=template&id=f9aad28e", function () {
      api.rerender('f9aad28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreatePoints.vue"
export default component.exports